import { render } from "./App.vue?vue&type=template&id=65d3432e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=65d3432e&lang=scss"

import exportComponent from "/private/var/www/work/zhixiaoyun/code/poster/haibao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__